import React from "react";
import { useSelector } from "react-redux";
import Summary from "../../../../components/cases/assets/balanceOfAssets/shareholdings/Summary";

const ShareHoldings = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);

  return (
    <>
      <Summary next={next} back={back} updates={updates} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="Shareholdings"
        setVisited={visited}
      /> */}
    </>
  );
};

export default ShareHoldings;
